
var Register = function () {

    var handleRegister = function () {

        $('.register-form').validate({
            errorElement: 'span', //default input error message container
            errorClass: 'help-block', // default input error message class
            focusInvalid: false, // do not focus the last invalid input
            ignore: "",
            rules: {
                email: {
                    required: true,
                    email: true
                },
                name: {
                    required: true

                },
                password: {
                    required: true
                },
                password_confirmation: {
                    required: true,
                    equalTo: "#password"
                },

            },
            messages: {
                email: {
                    required: "Az email cím megadása kötelező.",
                    email: "Az email cím nem megfelelő."
                },
                name: {
                    required: "A név megadása kötelező."
                },
                password: {
                    required: "A jelszó megadása kötelező."
                },
                password_confirmation: {
                    required: "A jelszó ismétlés megadása kötelező.",
                    equalTo: "A jelszó ismétlés nem egyezik."
                },
            },

            highlight: function (element) { // hightlight error inputs
                $(element).closest('.form-group').addClass('has-error'); // set error class to the control group
            },

            success: function (label) {
                label.closest('.form-group').removeClass('has-error');
                label.remove();
            },

            submitHandler: function (form) {
                form.submit();
            }
        });

        $('.register-form input').keypress(function (e) {
            if (e.which == 13) {
                if ($('.register-form').validate().form()) {
                    $('.register-form').submit();
                }
                return false;
            }
        });

    }

    return {
        //main function to initiate the module
        init: function () {
            handleRegister();
        }
    };

}();

$(document).ready(function () {
    Register.init();
});



// WEBPACK FOOTER //
// ./resources/assets/js/register.js